import React from 'react'

import Header from '../containers/Header'
import Footer from '../containers/Footer'

export default class Layout extends React.Component {
    render() {
        return (
            <div id="layout">
                <Header />
                <main>
                    {this.props.children}
                </main>
                <Footer />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/Layout.jsx